import React from "react";
import LeadLink from "web/react/components/lead-link/lead-link";
import { Text } from "web/react/emo/text/text";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./continue-to-option.module.css";

interface ContinueToOptionProps {
    href?: string;
    continueMessage: string;
    analyticsEventLabel: string;
    isTrackedLink?: boolean;
    reason?: string;
    productId?: string;
    continueClick?: (event) => void;
    closeModal?: () => void;
}

export default function ContinueToOption({
    href,
    continueMessage,
    analyticsEventLabel,
    isTrackedLink = false,
    reason = "continue-to-retailer",
    productId,
    continueClick,
    closeModal,
}: ContinueToOptionProps): JSX.Element {
    function onClick(callbackFunction, event): void {
        event.preventDefault();

        const action = isTrackedLink ? "lead_click" : "continue_clicked";
        analytics.event("send_to_app", action, analyticsEventLabel);

        callbackFunction?.(event);
        continueClick?.(event);
        closeModal?.();

        window.open(href, "_self");
    }

    return (
        <>
            <div className={styles.orContainer}>
                <Text as={"span"} className={styles.or} textStyle={"caption-1"}>
                    {gettext("in_stock_product.or_separator")}
                </Text>
            </div>
            {isTrackedLink && href ? (
                <LeadLink
                    href={href}
                    openInNewTab={true}
                    productId={productId}
                    reason={reason}
                    beforeOnClick={(callback, event): void => {
                        onClick(callback, event);
                    }}
                >
                    <span className={styles.continueMessage}>{continueMessage}</span>
                </LeadLink>
            ) : (
                <a
                    className={styles.continueLink}
                    href={href}
                    onClick={(event): void => {
                        onClick(null, event);
                    }}
                >
                    <span className={styles.continueMessage}>{continueMessage}</span>
                </a>
            )}
        </>
    );
}
